<app-filter-view-header
  class="filter-view-header"
  (resetFilterFn)="clearAllFilters()"
  (closePanel)="onClosePanel()"
  [showFilterIcon]="showFilterIcon"
  [showCloseButton]="showCloseButton"
  [showResetButton]="!!(filtersService.hasClearableFilters$ | async)"
></app-filter-view-header>
<div class="filters-list">
  <ng-container *ngFor="let filter of filtersService.filtersData$ | async; last as isLast">
    <app-generic-pencil-filter
      [title]="filter.title | translate"
      [filterKey]="filter.key"
      [hasDivider]="!isLast || showLastDivider"
      [isLocked]="filter.isLocked"
      (resetFilterFn)="handleClearFilter(filter)"
    >
      <ng-container
        [ngTemplateOutlet]="filterTypeToTemplateMap.get(filter.type)"
        [ngTemplateOutletContext]="{ filter: filter }"
      ></ng-container>
    </app-generic-pencil-filter>
  </ng-container>
</div>

<!-- Templates for different filter types -->
<ng-template #siteSearch let-filter="filter">
  <app-pencil-multi-select-tags
    [addableList]="filter.addableList"
    [selectedList]="filter.selectedList"
    [maxShownTags]="3"
    [hasEditOption]="false"
    [canEdit]="true"
    (selectedItemsChange)="handleFilterApplied(filter, $event)"
    [valuePropName]="'name'"
  >
  </app-pencil-multi-select-tags>
</ng-template>

<ng-template #userSearch let-filter="filter">
  <app-pencil-user-search-tags
    (emitUsersSelected)="handleFilterApplied(filter, $event)"
    [selectedUsers]="filter.selectedUsers"
    [placeholder]="'Add' | translate"
  ></app-pencil-user-search-tags>
</ng-template>

<ng-template #checkBoxFilter let-filter="filter">
  <div class="checkbox-filter-container">
    <input
      [id]="'checkbox-filter-' + filter.key"
      class="checkbox-filter"
      value="filter.isChecked"
      type="checkbox"
      [(ngModel)]="filter.isChecked"
      (ngModelChange)="handleFilterApplied(filter, filter.isChecked)"
    />
    <label class="checkbox-filter-label" [for]="'checkbox-filter-' + filter.key">
      {{ filter.label | translate }}
    </label>
  </div>
</ng-template>

<ng-template #dateFilter let-filter="filter">
  <app-pencil-button
    [dateRangePicker]="dateRangePickerRef"
    class="selection-menu"
    [label]="filter.dateRange ?? undefined | dateRangePickerSelectionNoLabel"
    [icon]="'expand_more'"
    [iconConfig]="{ type: 'mat-icon' }"
  >
  </app-pencil-button>

  <app-date-range-picker
    #dateRangePickerRef
    (applyButtonClicked)="handleFilterApplied(filter, $event)"
    [maxDateRangeDays]="null"
  >
  </app-date-range-picker>
</ng-template>

<ng-template #multiSelectFilter let-filter="filter">
  <app-pencil-multi-select-tags
    [addableList]="filter.addableList"
    [selectedList]="filter.selectedList"
    [maxShownTags]="3"
    [hasEditOption]="false"
    [canEdit]="true"
    (selectedItemsChange)="handleFilterApplied(filter, $event)"
    [keyPropName]="'_id'"
    [valuePropName]="filter.valuePropName ?? 'value'"
  >
  </app-pencil-multi-select-tags>
</ng-template>

<ng-template #modalFilter let-filter="filter">
  <app-pencil-multi-select-modal
    [selectedList]="filter.selectedList"
    [maxShownTags]="3"
    [canEdit]="true"
    (selectedItemsChange)="handleFilterApplied(filter, $event)"
    [keyPropName]="'_id'"
  >
  </app-pencil-multi-select-modal>
</ng-template>
